import { NoiseMapController, NoiseMapContent } from './components/NoiseMap'

export { default } from './LandNoise'

export const NoiseMapConfig = {
  Content: NoiseMapContent,
  Controller: NoiseMapController,
}
